import { Button, Card, Col, Form, Input, Row, Table } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { GlobalContext } from "../../context/GlobalContext";
import { fetchAllInterviewByCampaignId } from "../../services/interview.service";
import {getTimeAgo, maskName} from "../../utils/common";
import debounce from 'lodash.debounce';
import {roleValues as rolesValues, roleValues} from "../../config/roles";

const columns = [
  {
    title: "SN",
    key: "sno",
    dataIndex: "sno",
    width: "10px",
  },
  {
    title: "Personal Code",
    dataIndex: "personalCode",
    key: "personalCode",
    sorter: (a, b) => a.personalCodeSort.localeCompare(b.personalCodeSort),
  },
  // {
  //   title: "Full Name",
  //   dataIndex: "fullName",
  //   key: "fullName",
  //   sorter: (a, b) => a.fullNameSort.localeCompare(b.fullNameSort),
  // },
  {
    title: "Contact",
    key: "contactNumber",
    dataIndex: "contactNumber",
    sorter: (a, b) => a.contactNumberSort.localeCompare(b.contactNumberSort),
  },
  {
    title: "Address",
    key: "address",
    dataIndex: "address",
    sorter: (a, b) => a.addressSort.localeCompare(b.addressSort),
  },
  {
    title: "DATE ADDED",
    key: "created",
    dataIndex: "created",
    sorter: (a, b) => new Date(a.createdSort) - new Date(b.createdSort),
  },
  {
    title: "Created By",
    key: "createdBy",
    dataIndex: "createdBy",
    sorter: (a, b) => a.createdBySort.localeCompare(b.createdBySort),
  },
  // {
  //   title: "Location",
  //   key: "location",
  //   dataIndex: "location",
  // },
];

export const Interview = (props) => {
  const { user } = useContext(GlobalContext);
  const [maskState, setMaskState] = useState([]);
  const [maskStatePhone, setMaskStatePhone] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const navigate = useNavigate();

  const [formData] = useState({ fullName: '', address: '', contactNumber: '', personalCode: '' });
  const [form] = Form.useForm();

  useEffect(() => {
    loadDataFromServer();
  }, []);
  useEffect(() => {
    loadDataFromServer();
  }, [maskState, maskStatePhone])
  const handleFullNameMasking = (uuid) => {
      setMaskState((prevState) => [...prevState, uuid]);
  }
  const handleFullNameUnMasking = (uuid) => {
    setMaskState((prevState) => prevState.filter((item) => item !== uuid));
  }
  const handlePhoneMasking = (uuid) => {
    setMaskStatePhone((prevState) => [...prevState, uuid]);
  }
  const handlePhoneUnMasking = (uuid) => {
    setMaskStatePhone((prevState) => prevState.filter((item) => item !== uuid));
  }
  const loadDataFromServer = () => {
    const formValues = form.getFieldsValue();
    if (user?.role === roleValues.dataProtectionOfficer) {
      formValues.createdBy = user.id;
    }
    fetchAllInterviewByCampaignId(props?.campaignID, formValues).then((response) => {
      let count = 0;
      const data = response.data.map((interview) => {
        count++;
        return {
          key: interview.uuid,
          sno: (
            <>
              <div>
                <span>{count}</span>
              </div>
            </>
          ),
          snoSort: count,
          created: (
            <>
              <div className="ant-employed">
                <span>{getTimeAgo(interview.createdAt)}</span>
              </div>
            </>
          ),
          createdSort: interview.createdAt,
          fullNameSort: interview.basicInfo.fullName,
          personalCode:(
            <>
            <div>
              <NavLink to={`/location/${interview.campaign.uuid}/interview/detail/${interview.uuid}`}>
                {interview.basicInfo.personalCode || 'n/a'}
              </NavLink>
            </div>
            </>
          ),
          personalCodeSort: interview.basicInfo.personalCode,
          contactNumber: (
            <>
              <div className="ant-employed">
                <span>
                  {maskStatePhone.includes(interview.uuid) ? interview.basicInfo.contactNumber : maskName(interview.basicInfo.contactNumber)}
                  {user?.role === rolesValues.admin && <>
                    {!maskStatePhone.includes(interview.uuid) && <> <EyeInvisibleOutlined
                        onClick={() => handlePhoneMasking(interview.uuid)}/></>}
                    {maskStatePhone.includes(interview.uuid) && <> <EyeOutlined
                        onClick={() => handlePhoneUnMasking(interview.uuid)}/></>}
                  </>
                  }
                  </span>
              </div>
            </>
          ),
          contactNumberSort: interview.basicInfo.contactNumber,
          createdBy: (
              <>
                <div className="ant-employed">
                  <span>{interview?.createdBy?.fullName || 'N/A'}</span>
                </div>
              </>
          ),
          createdBySort: interview?.createdBy?.fullName,
          address: (
              <>
                <div className="ant-employed">
                  <span>{interview.basicInfo.address}</span>
                </div>
              </>
          ),
          addressSort: interview.basicInfo.address,
        };
      });
      setInterviews(data);
    }).catch((error) => console.log(error));
  }
  const handleSearch = debounce(() => {
    loadDataFromServer();
  }, 500);
  return (
    <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={(<div>{user?.role === roleValues.dataProtectionOfficer
                  ? `Survivors added by you`
                  : user?.role === roleValues.projectCoordinator ? `Survivors in this district`: `All Survivors`} ({interviews.length})</div>)}
              extra={
                <>{ (user?.role === roleValues.admin || user?.role === rolesValues.dataProtectionOfficer) &&
                    <Button
                        type="primary"
                        onClick={() => navigate(`/location/${props.campaignUUID}/interview/create`)}
                    >
                      Add New Survivor
                    </Button>
                }
                </>
              }
            >
              <Form
              form={form}
              style={{ padding: "10px", paddingLeft: 20, paddingBottom: 0 }}
              layout="vertical"
              key={JSON.stringify(formData)}
              initialValues={formData}>
                <Row gutter={[24, 0]}>
                  <Col xs={24} md={6} xl={6}>
                    <Form.Item
                      name="personalCode"
                      label="Personal Code" >
                        <Input onChange={handleSearch}/>
                      </Form.Item>
                  </Col>
                  <Col xs={24} md={6} xl={6}>
                    <Form.Item
                      name="contactNumber"
                      label="Contact" >
                        <Input onChange={handleSearch}/>
                      </Form.Item>
                  </Col>
                  <Col xs={24} md={6} xl={6}>
                    <Form.Item
                      name="address"
                      label="Address" >
                        <Input onChange={handleSearch}/>
                      </Form.Item>
                  </Col>
                </Row>
              </Form>
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={interviews}
                  pagination={{
                    pageSize: 20,
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
  );
};

export default Interview;
